import React, { CSSProperties } from "react";

interface INumericInput {
    name: string;
    defaultVal?: number;
    required?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    dataTestId?: string;
    style?: CSSProperties;
    step?: string
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    min?: number;
    value?: number;
}

const NumericInput = React.forwardRef<HTMLInputElement, INumericInput>((props, ref?) => {
    const defaultStyles: CSSProperties = {
        height: '5vh',
        border: '1px solid #C4C4C4',
        borderRadius: '10px',
    };

    return (
        <input
            style={{...defaultStyles, ...props.style}}
            type="number"
            name={props.name}
            defaultValue={props.defaultVal}
            required={props.required}
            onChange={(event) => props.onChange ? props.onChange(event) : {}}
            onBlur={(event) => props.onBlur ? props.onBlur(event) : {}}
            data-testid={props.dataTestId || "numericInput"}
            step={props.step || "any"}
            min={props.min}
            value={props.value}
            ref={ref}
        />
    );
});

export default NumericInput;
